export default {"src":"/_next/static/media/eyeOpen.26c931f6.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};